export const type = 'ECD/clearPageEvents';

export default page => ({
  type,
  payload: page,
});
